module.exports = __webpack_public_path__ + "static/d38e95d655a70761740b2e45e1866c5b03f97563f1a94454729dd379e87daf10-42b6c5bc4c72f8b4aaca9837c1dcb5e2.png";